<div class="form-section">
  <label [attr.for]="id" [class.required-field]="required" *ngIf="label">{{ label }}</label>
  
  <div class="fill-in-container">
    <ng-container *ngFor="let part of parsedTemplate.parts">
      <!-- 靜態文字部分 -->
      <span *ngIf="part.type === 'text'" class="fill-in-text">{{ part.content }}</span>
      
      <!-- 填空格部分 -->
      <ng-container *ngIf="part.type === 'field' && part.fieldId">
        <!-- 預覽模式 -->
        <div *ngIf="preview" class="fill-in-field preview" [ngClass]="getFieldClass(part.fieldConfig)">
          [{{ part.fieldId }}]
        </div>
        
        <!-- 編輯模式 -->
        <input 
          *ngIf="!preview"
          [type]="getInputType(part.fieldConfig)"
          [placeholder]="getPlaceholder(part.fieldConfig)"
          [ngModel]="fieldValues[part.fieldId]"
          (ngModelChange)="onFieldValueChange(part.fieldId, $event)"
          (blur)="onTouched()"
          [class]="getFieldClass(part.fieldConfig)"
        />
      </ng-container>
    </ng-container>
  </div>
</div>